module.exports = __webpack_public_path__ + "static/media/read_card.2f15a835.svg";